export const baseStrapiGetAttributes = (data: object) => {
  const rawData = toRaw(data?.value ? data.value : data)
  if (!rawData) { return null }
  if ((rawData instanceof Object) === false) { return null }
  if (rawData?.attributes) {
    return rawData?.attributes
  } else if (rawData?.data?.attributes) {
    return rawData?.data?.attributes
  } else if (rawData instanceof Array && rawData?.length && rawData[0]?.attributes) {
    return rawData[0]?.attributes
  } else if (rawData?.data instanceof Array && rawData?.data?.length && rawData?.data[0]?.attributes) {
    return rawData?.data[0]?.attributes
  } else if (rawData?.data?.attributes instanceof Array && rawData?.data?.attributes?.length && rawData?.data?.attributes[0]) {
    return rawData?.data?.attributes[0]
  } else {
    return null
  }
}
